import { render, staticRenderFns } from "./DetailTemplatePrimary.vue?vue&type=template&id=068cf154&scoped=true&"
import script from "./DetailTemplatePrimary.vue?vue&type=script&lang=js&"
export * from "./DetailTemplatePrimary.vue?vue&type=script&lang=js&"
import style0 from "./DetailTemplatePrimary.vue?vue&type=style&index=0&id=068cf154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068cf154",
  null
  
)

export default component.exports